import React, {useRef, useState, useEffect} from 'react';
import GameCard from "../GameCard/GameCard";
import {FormattedMessage} from "react-intl";

import './GameSlider.style.scss';
const GameSlider = ({vm}) => {
    const selectedGame = vm.filters.gameId;
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [showArrowButton, setShowArrowButton] = useState(false);
    const [isAtStart, setIsAtStart] = useState(true);
    const [gameSliderWidth, setGameSliderWidth] = useState(0);
    const [sliderWidth, setSliderWidth] = useState(0);
    const [showAllWidth, setShowAllWidth] = useState(0);
    const [gameCardWidth, setGameCardWidth] = useState(0);

    const gameSliderRef = useRef(null);
    const sliderRef = useRef(null);
    const showAllRef = useRef(null);
    const gameCardRef = useRef(null);

    const handleOnGameClick = (gameId) => {
        const value = gameId === selectedGame ? null : gameId;
        vm.handleFilterChange("gameId", value);
    };

    const slideLeft = () => {
        sliderRef.current.scrollLeft -= 200;
    };

    const slideRight = () => {
        sliderRef.current.scrollLeft += 200;
    };

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - sliderRef.current.offsetLeft);
        setScrollLeft(sliderRef.current.scrollLeft);
    };

    const handleMouseLeave = () => {
        setIsDragging(false);
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - sliderRef.current.offsetLeft;
        const walk = (x - startX) * 2;
        sliderRef.current.scrollLeft = scrollLeft - walk;
    };

    const handleTouchStart = (e) => {
        setIsDragging(true);
        setStartX(e.touches[0].pageX - sliderRef.current.offsetLeft);
        setScrollLeft(sliderRef.current.scrollLeft);
    };

    const handleTouchEnd = () => {
        setIsDragging(false);
    };

    const handleTouchMove = (e) => {
        if (!isDragging) return;
        const x = e.touches[0].pageX - sliderRef.current.offsetLeft;
        const walk = (x - startX) * 2;
        sliderRef.current.scrollLeft = scrollLeft - walk;
    };

    const handleScroll = () => {
        if (sliderRef.current.scrollLeft === 0) {
            setIsAtStart(true);
        } else {
            setIsAtStart(false);
        }
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            if(sliderRef.current) {
                setSliderWidth(sliderRef.current.offsetWidth);
            }
            if(gameSliderRef.current) {
                setGameSliderWidth(gameSliderRef.current.offsetWidth);
            }
            if(showAllRef.current) {
                setShowAllWidth(showAllRef.current.offsetWidth);
            }
            if(gameCardRef.current) {
                setGameCardWidth(gameCardRef.current.offsetWidth);
            }
        }, 2000);

        return () => clearTimeout(timeout);
    }, []);

    useEffect(() => {
        if(gameCardWidth && gameSliderWidth && showAllWidth) {
            const gameCardsWidth = vm.filteredGames.length * gameCardWidth;
            const allFiltersWidth = (showAllWidth + gameCardsWidth) + 60;
            setShowArrowButton(allFiltersWidth > gameSliderWidth);
        }
    }, [gameCardWidth, gameSliderWidth, showAllWidth]);


    useEffect(() => {
        const slider = sliderRef.current;
        slider.addEventListener('scroll', handleScroll);

        return () => {
            slider.removeEventListener('scroll', handleScroll);
        };
    }, []);



    return (
        <div className={`gameSlider`} ref={gameSliderRef}>
            {!isAtStart && <div className={"slideButton left"} onClick={slideLeft}>
                <i className={`fa-solid fa-angle-left`}/>
            </div>}
            <div className={"showAll " + (!selectedGame ? "selected gold-gradient-border " : "")}
                 onClick={() => handleOnGameClick(null)}
                 ref={showAllRef}
            >
                <FormattedMessage id="lobbyView.filter.showAllGames"/>
            </div>
            <div className="slider"
                 ref={sliderRef}
                 onMouseDown={handleMouseDown}
                 onMouseLeave={handleMouseLeave}
                 onMouseUp={handleMouseUp}
                 onMouseMove={handleMouseMove}
                 onTouchStart={handleTouchStart}
                 onTouchEnd={handleTouchEnd}
                 onTouchMove={handleTouchMove}
            >
                {vm.filteredGames.map((game, index) => (
                    <GameCard
                        key={game.GameId}
                        game={game}
                        isSelected={selectedGame === game.GameId}
                        onSelect={() => handleOnGameClick(game.GameId)}
                        gameCardRef={gameCardRef}
                    />
                ))}
            </div>
            {showArrowButton && <div className={"slideButton right"} onClick={slideRight}>
                <i className={`fa-solid fa-angle-right`}/>
            </div>}
        </div>
    );
};

export default GameSlider;
